import { Injectable, Output, EventEmitter, Directive } from '@angular/core';
import { TrackModalService } from '@core/services/track-open-modals.service';
import { ModalComponent } from '@shared/components/modal-base/index';
import { BehaviorSubject } from 'rxjs';
import { CiamFlagsService } from '@core/services/ciam-flags.service';

@Directive()
@Injectable()
export class ModalService {

  /** Sign-in modal: identifier-first (CIAM V6) vs legacy signin-body. */
  getSignInModalSelector(): string {
    return this.ciamFlagsService.isCiamV6Com() || this.ciamFlagsService.isIdentifierFirst()
      ? 'app-identifier-first-signin'
      : 'app-signin-body';
  }

  /** Sign up modal: unified identifier-first flow (ciamV6Com) vs legacy email/password register. */
  getSignupModalSelector(): string {
    return this.ciamFlagsService.isCiamV6Com() ? 'app-identifier-first-signin' : 'app-register';
  }
  private standardModal: ModalComponent;
  private flyoutModal: any;
  modalOptions=new BehaviorSubject('');

  @Output() btnEvent = new EventEmitter<any>();


  constructor(
    private trackModalService: TrackModalService,
    private ciamFlagsService: CiamFlagsService
  ) {
  }

  public setFlyoutModal(component: any) {
    this.flyoutModal = component;
  }

  public setFlyoutBody(name: string) {
    if (this.flyoutModal) this.flyoutModal.setCompSelector(name);
  }

  public toggleFlyout(action: string = '') {
    this.flyoutModal.toggle(action);
  }

  public setModalBody(name: string) {
    if (this.standardModal) this.standardModal.setCompName(name);
  }

  public setModalSelector(name: string, options?: any) {
    if (!this.standardModal) return;
    this.standardModal.setCompSelector(name);
    this.modalOptions.next(options);
  }

  private timeout(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  public setModal(component: any) {
    this.standardModal = component;
  }

  public deregister(): void {
    this.standardModal = null;
    this.trackModalService.setModalOpen(false);
  }

  public isModalOpen(): boolean {
    return this.trackModalService.getModalOpen();
  }

  public async showModal(autoHide: boolean = true, timeOutLength: number = 3000) {
    if (!this.standardModal) return;
    if (this.trackModalService.getModalOpen()) {
      this.hideModal();
      await this.timeout(timeOutLength);
    }

    this.standardModal.show(autoHide);
    document.body.classList.add('modal-open');
    this.trackModalService.setModalOpen(true);
  }



  public hideModal() {
    if (this.standardModal) this.standardModal.hide();
    if (!this.trackModalService.getConfirmOpen()) {
      document.body.classList.remove('modal-open');
    }
    this.trackModalService.setModalOpen(false);
  }

  onBtnEvent(data: any) {
    this.btnEvent.emit(data);

}
}
